const SettingsPage = () => {
    return (
        <div className='settings-page'>
            Settings page
        </div>
    )
}

export default SettingsPage